// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"140cfbea","408":"dabb4982","452":"f8f452c5","476":"09f243b3","580":"48e0e0ef","617":"a865a4bd","727":"79eafd62","876":"7e5958c3","910":"5cf3976c","925":"428aa1a9"}[chunkId] + ".chunk.js";
};